<template>
  <div>
    <h1>Login By ADFS</h1>
    <pre>{{ $route.query }}</pre>

    <div class="login middle-box text-center loginscreen animated fadeInDown">
      <form>
        <div class="m-t">
          <div class="login-panel">
            <div class="login-logo">
                <img alt="image" class="" src="static/img/logo_nav.png" />
            </div>
            <!-- <p class="text-muted">Sign in with your organizational account</p> -->
            <div @click="loginByAdfs" class="login-btnset"><button class="btn btn-success block m-b">ADFSを利用して始める</button></div>
          </div>
        </div>
      </form>
    </div>

  </div>
</template>

<script>

export default {
  name: 'LoginByADFS',
  data () {
    return {
      token: ''
    }
  },
  created () {
    console.log('created')
    console.log('Cookie:', document.cookie)
  },
  methods: {
    loginByAdfs: function () {
      this.$router.replace({ name: 'okr' })
    },
    login: function () {
      const $t = this.$t
      if (!this.$v.email.required) {
        this.$swal({
          title: $t('noEmailStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      } else if (!this.$v.password.required) {
        this.$swal({
          title: $t('notPasswordString'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      }
      if (this.$v.email.required && this.$v.password.required) {
        this.$firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            // alert(user.id)
            console.log(user)
            this.$router.replace({ name: 'okr' })
          },
          (err) => {
            if (err.code === 'auth/invalid-email') {
              this.$swal({
                title: $t('notEmailStr'),
                type: 'warning',
                animation: false,
                customClass: 'animated fadeInUp',
                // customClass: 'animated flipInX',
                width: '35rem',
                position: 'center',
                // toast: true,
                padding: '2rem',
                timer: 3000
              })
            } else {
              this.$swal({
                title: this.$t('incorrectInputMessageString'),
                type: 'warning',
                animation: false,
                customClass: 'animated fadeInUp',
                // customClass: 'animated flipInX',
                width: '35rem',
                position: 'center',
                // toast: true,
                padding: '2rem',
                timer: 4000
              })
            }
          }
        )
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-panel {
  padding: 5em 2em 5em;
}
.login-logo {
  /* margin: 0 auto 3em; */
  margin: 0 auto 5em;
}
.text-muted{
  margin-bottom: 5em;
}
button {
  font-size: 1.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginByADFS.vue